// components/Loader.jsx
import React from 'react';
import './Loader.css'; // Assurez-vous d'importer le CSS

const Loader = () => {
  return <span className="loader"></span>;
};

export default Loader;
